import { useEffect, useState } from "react";
import { api } from "@/api";
import { useSite } from "@/lib/site";
import SeoHead from "@/lib/SeoHead";
import InquiryForm from "@/components/InquiryForm";
import { Phone, Mail, MapPin, Clock } from "lucide-react";

export default function Contact() {
  const { settings } = useSite();
  const [page, setPage] = useState(null);
  useEffect(() => { /* placeholder for future */ setPage({}); }, []);

  return (
    <>
      <SeoHead title="Contact Durga Auto Industries — Request a Quote" description="Get in touch for fastener quotations, technical support and partnership enquiries." />
      <section className="bg-[#1C1C1C] text-white pt-20 pb-16 border-b border-[#333]">
        <div className="container-x">
          <div className="overline mb-5">Contact</div>
          <h1 className="font-heading font-bold text-4xl md:text-5xl">Let's build something durable.</h1>
          <p className="mt-4 body-lg text-white/70 font-body max-w-2xl">
            Reach our sales engineering team for quotations, drawing reviews and partnership conversations.
          </p>
        </div>
      </section>

      <section className="section-y bg-white">
        <div className="container-x grid grid-cols-1 lg:grid-cols-[1fr_1.2fr] gap-12">
          <div className="space-y-6" data-testid="contact-info">
            <ContactItem Icon={Phone} title="Call us" value={settings?.contact_phone} href={`tel:${settings?.contact_phone}`} />
            <ContactItem Icon={Mail} title="Email" value={settings?.contact_email} href={`mailto:${settings?.contact_email}`} />
            <ContactItem Icon={MapPin} title="Visit our facility" value={settings?.contact_address} />
            <ContactItem Icon={Clock} title="Working hours" value="Mon — Sat · 9:00 AM – 6:30 PM IST" />

            {settings?.map_embed_url && (
              <div className="aspect-[4/3] mt-6 border border-[#E5E7EB]">
                <iframe
                  title="Map"
                  src={settings.map_embed_url}
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  data-testid="contact-map"
                />
              </div>
            )}
          </div>
          <InquiryForm variant="light" title="Send us an enquiry" subtitle="We'll respond within one business day." />
        </div>
      </section>
    </>
  );
}

function ContactItem({ Icon, title, value, href }) {
  const inner = (
    <div className="flex items-start gap-4">
      <div className="w-12 h-12 bg-[#1C1C1C] text-[#C1121F] flex items-center justify-center flex-shrink-0">
        <Icon size={20} />
      </div>
      <div>
        <div className="overline mb-1">{title}</div>
        <div className="font-heading text-lg font-semibold text-[#1C1C1C]">{value || "—"}</div>
      </div>
    </div>
  );
  return href ? <a href={href} className="block hover:translate-x-1 transition-transform">{inner}</a> : inner;
}
